// 잿불 리더는 주술사 클립을 사용한다. 선딜 마지막 자세와 발동 첫 자세를 연결한다.
import { BOSS_EMBER, BOSS_TIMING } from '../../shared/config';
import { BossState } from '../../shared/types';
import { clipFrame, type SkinAtlas } from './skinning';
const p = (t: number, n: number): number => Math.max(0, Math.min(1, t / n));
export const EMBER_HEIGHT = 3.6;
export function emberCasting(state: number): boolean {
  return state === BossState.SlamWindup || state === BossState.SweepWindup || state === BossState.Cast || state === BossState.Summon;
}
export function emberFrame(a: SkinAtlas, state: number, tick: number, cycle: number, moving: boolean): number {
  const attack = a.clips.attack.duration, impact = attack * 0.75;
  switch (state) {
    case BossState.Intro: return clipFrame(a, 'spawn', a.clips.spawn.duration * p(tick, BOSS_TIMING.intro));
    case BossState.Chase: return clipFrame(a, moving ? 'run' : 'idle', cycle, true);
    case BossState.SlamWindup: return clipFrame(a, 'attack', impact * p(tick, BOSS_EMBER.novaWindup));
    case BossState.SweepWindup: return clipFrame(a, 'attack', impact * p(tick, BOSS_EMBER.fissureWindup));
    case BossState.Cast: return clipFrame(a, 'attack', attack * p(tick, BOSS_EMBER.meteorGap * (BOSS_EMBER.meteorCount - 1) + BOSS_EMBER.meteorWindup));
    case BossState.Slam:
    case BossState.Sweep: return clipFrame(a, 'attack', impact + (attack - impact) * p(tick, BOSS_TIMING.strike));
    case BossState.Summon: return clipFrame(a, 'attack', attack * p(tick, BOSS_TIMING.summon));
    case BossState.Stagger: return clipFrame(a, 'hit', a.clips.hit.duration * p(tick, BOSS_TIMING.stagger));
    case BossState.Dying: return clipFrame(a, 'death', a.clips.death.duration * p(tick, BOSS_TIMING.dying));
    case BossState.Dead: return clipFrame(a, 'death', a.clips.death.duration);
    default: return clipFrame(a, 'idle', cycle, true);
  }
}
